import AppConstants from '../../AppConstants';
import mixpanel from 'mixpanel-browser';
import SuperProperty from './Model/superProperty';
import People from './Model/people';
import { getAnonymousId, getRole, getUserSessionId } from '../../Model/UserProperties';

export function initializeMixpanel() {
  const mixpanelConfig = {
    disable_persistence: true
  };

  mixpanel.init(AppConstants.MIXPANEL_TOKEN, mixpanelConfig);
  mixpanel.init(AppConstants.MIXPANEL_CROSS_PLATFORM_TOKEN, mixpanelConfig, 'crossProduct');
}

function setSuperProperty(superProperty) {
  if (!(superProperty instanceof SuperProperty)) {
    throw new Error('Cannot set super property without an object of SuperProperty instance');
  }
  mixpanel.register(superProperty);
  mixpanel.crossProduct.register(superProperty);
}

function setPeopleProperty(people) {
  if (!(people instanceof People)) {
    throw new Error('Cannot set people property without an object of People instance');
  }
  mixpanel.people.set(people);
}

function identifyUser(userId) {
  if (typeof userId !== 'string') {
    throw new Error('Cannot identify user without a user Id.');
  }
  mixpanel.identify(userId);
  mixpanel.crossProduct.identify(userId);
}

export function initMixpanelFromUser(user, metadata) {
  if (user === null) {
    identifyUser('-1');
    return;
  }

  identifyUser(user.userKey);
  const mixpanelSuperProperty = new SuperProperty()
    .setUserKey(user.userKey)
    .setAccountKey(metadata.accountKey)
    .setAnonymousId(getAnonymousId())
    .setUserSessionId(getUserSessionId())
    .setUserLocale(user.locale)
    .setEntitlements(user.entitlements)
    .setRole(getRole(user.entitlements))
    .setUserTimezone(user.userTimeZone)
    .setPricingTier(metadata.description)
    .setChannel(metadata.channel)
    .setAccountCreated(user.created)
    .build();
  setSuperProperty(mixpanelSuperProperty);

  const mixpanelPeopleProperty = new People().setUserKey(user.userKey).build();
  setPeopleProperty(mixpanelPeopleProperty);
}

export function reset() {
  mixpanel.reset();
  mixpanel.crossProduct.reset();
}



// WEBPACK FOOTER //
// ./src/Telemetry/Mixpanel/mixpanelClient.js